import { useRouter } from 'next/compat/router';
import { graphql } from 'react-relay';
import Icon from '@/core/icon';
import { lang } from '@/helpers/translate';
import { getPathByLang } from '@/helpers/router';
import { wasUseFragment as useFragment } from '@/helpers/common';

const fragment = graphql`
  fragment bookmark_book on Bookmark {
    ref
    spaceCounting
    spaceIds
  }
`;

function Bookmark({ className, book }) {
  const router = useRouter();
  const langCurrent = lang();
  const data = useFragment(fragment, book);

  if (!data || !data.ref || !data.spaceCounting) return null;

  function onClick(ref) {
    router.push(getPathByLang('bookmark', langCurrent, { ref }));
  }

  return (
    <div className={className} onClick={() => onClick(data.ref)}>
      <Icon className="w-4 h-4 mr-1 fill-current text-purple-4" name="heart" />
      {data.spaceCounting}
    </div>
  );
}

export { fragment };
export default Bookmark;
